// Case Studies page content — duplicated from thisisitinfo.com/patents-and-studies-on-x39
// External PDFs/links open in a new tab; in-page links scroll to anchors only.
export const CASE_STUDIES = {
  intro: {
    title: "Science & Research — LifeWave X39",
    tagline:
      "Eight independent studies show that our flagship X39 patch works to increase copper-peptide production in blood, which can improve tissue repair, stimulate blood vessel and nerve growth, and improve skin.",
    extra:
      "A double-blind randomized control study published in the International Journal of Research Studies in Medical and Health Sciences revealed a significant increase in the production of 8 amino acids, which improved short-term memory, sleep, and vitality.",
  },
  earlyStudies: [
    {
      title: "Study A",
      desc: "A double-blind test published in the Journal of Internal Medicine Research showed a significant increase in copper-peptide concentrations in the blood of subjects who had worn X39 patches for 1 week.",
      url: "https://static.showit.co/file/4hTZhahETD-fI8xp41WW2Q/117381/study-a.pdf",
    },
    {
      title: "Study B",
      desc: "A double-blind test published in the Journal of Internal Medicine Research showed a significant increase in copper-peptide concentrations in the blood of subjects who had worn X39 patches for 1 week.",
      url: "https://static.showit.co/file/9bQortJnT524yDoHgjCk5g/117381/study-b.pdf",
    },
  ],
  phototherapy: {
    title: "Phototherapy",
    body: [
      "By capturing visible and infrared light, LifeWave's health technology is revolutionizing the way we can leverage light to improve and extend our lives.",
      "For centuries, phototherapy has been used to improve health. Phototherapy, sometimes called light therapy or photobiomodulation, works by using a mechanism to reflect or shine light into the body to stimulate cellular activity. With LifeWave, our patches act as that mechanism, reflecting visible and infrared light back into the body.",
      "As an example, our X39 patch reflects light back into the body, stimulating cellular activity.",
    ],
    links: [
      {
        label: "Photobiomodulation or low-level light therapy",
        url: "https://static.showit.co/file/4rIYY-pVT66TPRjmH97FaA/117381/mechanisms-of-low-level-light-therapy.pdf",
      },
      {
        label: "Human infrared light",
        url: "https://pubmed.ncbi.nlm.nih.gov/19606225/",
      },
    ],
  },
  acupressure: {
    title: "Acupressure",
    body: [
      "Acupressure works like acupuncture, which is based on the concept that we all have a human energy field that flows through \u201cmeridians\u201d in the body. The belief held in traditional Chinese medicine is that blockages in those meridians cause health problems, disease, and illness.",
      "By applying slight pressure to various acupuncture points, each of which correspond to those meridians, the belief is that symptoms can be relieved. Various studies have demonstrated its effectiveness against things like pain and obesity.",
      "This study showed that acupressure was a safe, easy, and effective way for emergency responders to alleviate pain during transport to hospitals.",
    ],
    links: [
      {
        label: "Analgesia with acupressure in victims of minor trauma",
        url: "https://pubmed.ncbi.nlm.nih.gov/12198060/",
      },
      {
        label: "Acupressure and energy improvement",
        url: "https://static.showit.co/file/H7KHWUqtRmujyVrI0gCH1w/117381/energy-improvement_-fatigue_-and-acupressure.pdf",
      },
    ],
  },
  patents: {
    title: "Our Patents",
    body: [
      "Our patented technology is the difference.",
      "By reimagining the possibilities of science and wellness, LifeWave has revolutionized the way our bodies respond to phototherapy.",
      "US Patents: 10716953B1, 9943672B2, D745504, D746272, D745503, D745502, D745501, 9532942, 9263796, 9258395, 9149451, 8734316, 8602961",
    ],
    items: [
      {
        title: "Patch Technology",
        desc: "First-of-its-kind wearable apparatus that regulates thermodynamic energy flow throughout the body for improving strength and stamina and relieving pain.",
        url: "https://static.showit.co/file/W5pi-2OERp-QIFpgp5HKmA/117381/us-patent-8734316b2.pdf",
      },
      {
        title: "X39",
        desc: "A wearable phototherapy patch that produces beneficial effects to a human body such as improvement in strength, stamina, and pain relief.",
        url: "https://static.showit.co/file/oexDUkF0TMODeeD0ZqKflA/117381/us-patent-10716953-b1.pdf",
      },
    ],
  },
  research: {
    title: "Our Product Research",
    body: [
      "We're reimagining wellness.",
      "Backed by more than 80 independent studies conducted at world-class universities and research institutions, our unmatched health technology improves and extends lives.",
      "Experience LifeWave and discover the many ways in which our product innovations can make a difference in your healthy lifestyle:",
    ],
    studies: [
      {
        title: "Double-Blind Testing of the LifeWave X39 Patch to Determine GHK-Cu Production Levels",
        desc: "A double-blind test published in the journal Internal Medicine Research showed a significant increase in copper-peptide concentrations in the blood of subjects who had worn X39 patches for 1 week.",
        url: "https://static.showit.co/file/7czpjn10QGGQMU-WbZp4-A/117381/double-blind.pdf",
      },
      {
        title: "Phototherapy Induced Metabolism Change Produced by the LifeWave X39 Non-transdermal Patch",
        desc: "A double-blind randomized control study revealed that X39 patches caused a significant increase in the production of 8 amino acids, improving short-term memory, sleep, and vitality.",
        url: "https://static.showit.co/file/LRMbnLtcTVy_U8wzhYRkzQ/117381/phototherapy.pdf",
      },
      {
        title: "Changes in Tripeptides Produced by the LifeWave X39 Patch",
        desc: "Pilot study explored changes in GHK and GHK-Cu in blood from wearing X39 for 1 week. Significant increase of GHK in blood at 24 hours and 7 days.",
        url: "https://static.showit.co/file/t2qxZZikRF6hhuzN5Kxw6g/117381/changes-in-tripeptides.pdf",
      },
      {
        title: "Experimental Study of LifeWave, Inc. X39 Patches",
        desc: "The pilot study demonstrates statistically significant positive changes in the biofields of members of the experimental group when compared to the control group.",
        url: "https://static.showit.co/file/gavfld1LQF29UqI6tx7-wg/117381/experimental-study-of-lifewave-x-39-patches-report-final-draft-3.pdf",
      },
      {
        title: "LifeWave X39 Pilot Demonstrates Light Triggered Changes",
        desc: "Metabolic and physiological changes produced by participants wearing the LifeWave non-transdermal X39 phototherapy patch.",
        url: "https://static.showit.co/file/sC5Od9PuQfiHwd-AKnJx7w/117381/lifewave-x39-pilot-demonstrates-light-triggered-changes-may-2020.pdf",
      },
      {
        title: "Non-Invasive Scanning & Subtle Energy Testing — Effect of X39 on Brain (P3 Brain Mapping)",
        desc: "All participants showed dramatic changes in their scalp topographic maps reporting the amplitude of the P300 recording for each channel and in their coherence maps.",
        url: "https://static.showit.co/file/XUQdDRmZQnej3UHFu2rETQ/117381/x39-non-invasive-scanning-and-subtle-energy-testing-lab-effect-of-lifewave-x39-patches-on-brain-as-seen-with-p3-brain-mapping.pdf",
      },
      {
        title: "Metabolic Implications of the LifeWave X39 Patch — Study 1",
        desc: "Clear, significant metabolic changes over one week of wear suggest broader investigation over longer time-frames.",
        url: "https://static.showit.co/file/cMYgU7EuTw2gAYTnmPTzcA/117381/metabolic-implications-of-the-lifewave-x39-patch-study-1.pdf",
      },
      {
        title: "Metabolic Implications of the LifeWave X39 Patch — Study 4",
        desc: "Improvements in blood pressure, anti-inflammatory response, sleep, memory, and vitality over a 7-day period.",
        url: "https://static.showit.co/file/PmkmT-5BSOej5IQMxd0M6w/117381/metabolic-implications-of-the-lifewave-x39-patch-study-4.pdf",
      },
      {
        title: "Changes in GHK and GHK-Cu in Blood Produced by the LifeWave X39 Patch",
        desc: "Significant increase in GHK in the blood, seen at 24 hours and again at 7 days.",
        url: "https://static.showit.co/file/ajAIwR2TSMyD5NeBxWF4EQ/117381/changes-in-ghk-and-ghk-cu-in-blood-produced-by-the-lifewave-x39-patch.pdf",
      },
      {
        title: "Acupressure On Weight Reduction In Asian Young Adults",
        desc: "After 8 weeks of ear acupressure treatment by Japanese Magnetic Pearls, the average BMI decreased significantly.",
        url: "https://static.showit.co/file/SUvYF3eTTguSsKKotJWqtw/117381/auricular-acupressure-for-weight-reducation-in-obese-asian-young-adults-a-randomized-controlled-trial.pdf",
      },
      {
        title: "The Treatment Of Obesity By Acupuncture",
        desc: "Acupuncture stimulates the auricular branch of the vagal nerve, increases tone in the smooth muscle of the stomach, suppresses appetite, and helps mobilize body energy depots.",
        url: "https://static.showit.co/file/M7UicX2TRomiCiXjR_Du7Q/117381/treatment-of-obesity-by-acupuncture.pdf",
      },
    ],
  },
  acupressureInfo: {
    title: "Information on Acupressure",
    items: [
      {
        title: "Acupressure And Antioxidants",
        desc: "Auricular pellet acupressure can increase the concentration of antioxidative enzymes in persons with high-risk diabetes mellitus.",
        url: "https://static.showit.co/file/zK2JtI5ZSuCmgA9Q00-rBw/117381/acupressure-and-antioxidants.pdf",
      },
      {
        title: "Acupressure and Anti-Aging",
        desc: "Evidence documents the ability of acupressure to increase the length of telomeres — molecules at the ends of chromosomes.",
        url: "https://static.showit.co/file/SRv8AxylRGavF3_ytaKatQ/117381/acupressure-abstracts_anti-aging.pdf",
      },
      {
        title: "Acupressure And Pain Reduction",
        desc: "Acupressure was effective in reducing low back pain in disability, pain scores, and functional status — benefit sustained for six months.",
        url: "https://static.showit.co/file/f5a6epxCQpGGcA4sTecstg/117381/acupressure-and-pain-reduction.pdf",
      },
      {
        title: "Acupressure And Sleep Improvement",
        desc: "H7-insomnia control is efficacious to ameliorate quality of sleep and reduce anxiety in insomniacs.",
        url: "https://static.showit.co/file/_nMN3yYKT62SHMcWlwqVkA/117381/acupressure-and-sleep-improvement.pdf",
      },
      {
        title: "Acupressure And Mental Clarity",
        desc: "Use of an ancient Jewish prayer ritual that uses two small leather boxes placed on specific points on the head indicates correlation with acupressure.",
        url: "https://static.showit.co/file/26af48hZSz6ZW4NBqZWO5A/117381/acupressure-and-mental-clarity.pdf",
      },
      {
        title: "Acupressure And Morning Sickness",
        desc: "An acupressure wristband might be an alternative therapy for morning sickness in early pregnancy.",
        url: "https://static.showit.co/file/W4Z3qsyzRoSYMJV6NllNTw/117381/acupressure-treatment-of-morning-sickness-in-pregnancy-a-randomised-double-blind-placebo-controlled-study.pdf",
      },
      {
        title: "Different Types of Nanotechnology Devices",
        desc: "By Steve Haltiwanger, M.D., C.C.N.",
        url: "https://static.showit.co/file/HqihDo_gQNmKW0Kb35aWFg/117381/different-types-of-nanotechnology-devices.pdf",
      },
      {
        title: "Dr. Dean Clark",
        desc: "By Steve Haltiwanger, M.D., C.C.N.",
        url: "https://static.showit.co/file/mEN9WogbQWaCCqgoeWnvKw/117381/dr-dean-clark-letter.pdf",
      },
    ],
  },
  safety: {
    title: "Patch Mechanisms & Safety",
    items: [
      {
        title: "U.S. Anti-Doping Agency",
        url: "https://static.showit.co/file/HV5HqSeNTyKNKd7grQIdCw/117381/u_s_-anti-doping-agency.pdf",
      },
      {
        title: "World Anti-Doping Agency",
        url: "https://static.showit.co/file/RhhhepsWRj2wEuScxWZogg/117381/world-anti-doping-agency.pdf",
      },
      {
        title: "LifeWave Strength Test at Morehouse College",
        desc: "In this double-blind, placebo-controlled study, 44 student athletes at Morehouse wore either real LifeWave patches or placebo. The LifeWave group experienced a 34% average improvement in repetitions Monday→Thursday vs. only 4.9% for the placebo group.",
        url: "https://static.showit.co/file/QUpjSH56RM-CfJ-sxnrrhg/117381/lifewave-strength-test-morehouse-college.pdf",
      },
    ],
  },
  ceo: {
    title: "CEO & Founder — David Schmidt",
    bio: [
      "David is the inventor of LifeWave technology and founder and CEO of LifeWave.",
      "David's experience in business and product development spans over 30 years and includes a formal education in Management Information Systems and Biology at Pace University in Pleasantville, NY. David then went on to pursue several entrepreneurial endeavors and, as a result, owned successful companies involved in manufacturing and product development. One of these companies, Advanced Applications Group, is a research and development center that specialized in energy-production technologies for both military and commercial applications.",
      "As a result of his innovations, David was presented with an honorary doctorate by Dr. Alexander Marinaccio of the International Hall of Fame of Inventors. David was also invited to participate in the U.S. Navy's next generation mini-sub program as a result of work performed in the design of emergency oxygen systems for General Dynamics and the U.S. Navy.",
      "The LifeWave Technology was born out of three years of intense research by David into the concept of being able to naturally increase energy and stamina through elevation of fat burning, utilizing wireless communication to the human body via phototherapy.",
      "Globally, David is the holder of 94 issued patents, with many more being written. More than seventy of those issued patents are in the field of regenerative science and technology. One of his inventions, the Double Helix Conductor, produces a novel blend of electromagnetic and non-electromagnetic fields to improve the speed of wound healing that rivals that of stem-cell injections.",
    ],
    links: [
      {
        label: "David Schmidt: Up Close and Personal",
        url: "https://www.youtube.com/watch?v=-1exNliwTn4",
      },
      {
        label: "Chapter from \u201CBreakthrough\u201D by Suzanne Somers",
        url: "https://static.showit.co/file/sxFFYmVMQaiQZwWKzzXrVA/117381/lightwave-suzannesomerschapter33-lowres.pdf",
      },
    ],
  },
  disclaimer:
    "LifeWave products are not intended to diagnose, treat, cure or prevent any disease or medical condition. All content regarding the science behind LifeWave's products is based on and may contain elements for the science of both phototherapy and acupressure. LifeWave products are categorized under one of these two scientific classifications depending on local laws and regulations.",
};
